import { keys, assign } from "lodash";

import { routes as clinicalNotes } from "../../clinicalNotes";
import { routes as bloodTestConsultation } from "../../bloodTest";
import { routes as vaccinationConsultation } from "../../vaccinationConsultation";
import { routes as referralReport } from "../../referralReport";
import { routes as ppqReport } from "../../ppqReport";
import { routes as bbvReport } from "../../bbvReport";
import { routes as bbvConsultation } from "../../bbvConsultation/routes";
import { routes as mhpTreatmentConsultation } from "../../mentalHealthPractitionerTreatment/routes";
import { routes as immunisationReview } from "../../immunisationReview";
import { routes as immunisationOhCase } from "../../immunisationOhCase/routes";
import { routes as physiotherapyReferralReport } from "../../physiotherapyReferralReport";
import { routes as initialWorkAdjustmentQuestionnaire } from "../../workAdjustment/routes";
import { routes as healthSurveillance } from "../../healthSurveillance";
import { routes as genericCase } from "../../genericCases";
import { routes as physiotherapyAssessment } from "../../physiotherapy/routes";
import { routes as managerFeedbackOnReport } from "../../managerFeedbackOnReport/routes";
import { routes as employeeSatisfactionSurvey } from "../../employeeSatisfactionSurvey/routes";
import { routes as managerSatisfactionFollowUpQuestionnaire } from "../../managerSatisfactionFollowUpQuestionnaire/routes";

import { routes as closeTaskAndCreateFollowUpTask } from "./closeTaskAndCreateFollowUpTask/routes";
import { routes as furtherInformationAndReviewOfFitnessTask } from "./furtherInformationAndReviewOfFitness/routes";
import { routes as generalPractitionerSpecialist } from "./generalPractitionerSpecialist/routes";

const getRoutesWithCustomerAndOhCaseIds = (originalRoutes: any) => {
    return assign({}, ...keys(originalRoutes).map(r => ({ [`/:customerId/:ohCaseId${r}`]: originalRoutes[r] })));
};

const getRoutesWithCaseIds = (originalRoutes: any) => {
    return assign({}, ...keys(originalRoutes).map(r => ({ [`/:ohCaseId${r}`]: originalRoutes[r] })));
};

export const routesWithoutCustomerAndOhCaseIds = {
    ...clinicalNotes,
    ...bloodTestConsultation,
    ...vaccinationConsultation,
    ...referralReport,
    ...ppqReport,
    ...bbvReport,
    ...bbvConsultation,
    ...mhpTreatmentConsultation,
    ...immunisationReview,
    ...immunisationOhCase,
    ...closeTaskAndCreateFollowUpTask,
    ...furtherInformationAndReviewOfFitnessTask,
    ...healthSurveillance,
    ...genericCase,
    ...physiotherapyAssessment,
    ...physiotherapyReferralReport,
    ...initialWorkAdjustmentQuestionnaire,
    ...managerFeedbackOnReport,
    ...employeeSatisfactionSurvey,
    ...managerSatisfactionFollowUpQuestionnaire,
    ...generalPractitionerSpecialist
};

export const routes = getRoutesWithCustomerAndOhCaseIds(routesWithoutCustomerAndOhCaseIds);

export const routesWithCaseIds = getRoutesWithCaseIds(routesWithoutCustomerAndOhCaseIds);
